/* Sampling — moved out of pages/Sampling.jsx in split step 6d (28-Oct-2026), unchanged. The page's constants and helpers; Sampling.jsx imports them and re-exports the three confidence helpers. */

const CONTINUOUS_METHOD = "Continuous (100% Population)";

// Batch A · C12 spec — Arabic entry-count plural. Returns
// { number, suffix } so the caller can conditionally wrap the number
// in <Ref> (LTR-isolated) and only when the number is meaningful:
//   0 → "0 قيود"        (number "0" shown)
//   1 → "قيد واحد"      (no number)
//   2 → "قيدان"         (no number)
//   3–10 → "N قيود"     (number with thousand separators)
//   11–99 → "N قيدًا"
//   100+ → "N قيد"
// English mode returns the plain suffix so the caller renders
// `${fmtCount(count)} ${suffix}` unchanged.
const AR_PR_ENTRIES = new Intl.PluralRules("ar");
function arEntriesLabel(n, lang, t) {
  // App-wide rule: Western digits + thousand separators (en-US) in
  // both languages. Only the Arabic word for "entries" is localized.
  const NF = new Intl.NumberFormat("en-US");
  if (lang !== "ar") {
    return { number: NF.format(Number(n || 0)),
             suffix: t("samplingSelector.entriesSuffix") };
  }
  if (n === 1) return { number: null, suffix: "قيد واحد" };
  if (n === 2) return { number: null, suffix: "قيدان" };
  const localized = NF.format(Number(n || 0));
  if (n === 0) return { number: localized, suffix: "قيود" };
  const cat = AR_PR_ENTRIES.select(n);
  if (cat === "few") return { number: localized, suffix: "قيود" };
  if (cat === "many") return { number: localized, suffix: "قيدًا" };
  return { number: localized, suffix: "قيد" };
}
// Batch 9 · A19 (F-72): selecting specific items is NOT sampling — its own method, its own sheet marking.
// Step 7a · S16: the reference is ISA 500.A55–A56 (was "ISA 500.A53"; the back end still accepts the old name and stores the new one).
const SPECIFIC_METHOD = "Specific vouching - ISA 500.A55–A56";
const SPECIFIC_REASONS = [["key_item", "Key item", "بند رئيسي"], ["high_value", "High value", "قيمة مرتفعة"], ["unusual", "Unusual", "غير معتاد"],
                          ["cut_off", "Cut-off", "الفصل الزمني"], ["related_party", "Related party", "طرف ذو علاقة"], ["confirmation_follow_up", "Confirmation follow-up", "متابعة المصادقة"]];
const METHODS = ["Random", "Systematic", "MUS", "PPS", "Stratified", "Risk-Based", SPECIFIC_METHOD,
                  CONTINUOUS_METHOD];
const CATEGORIES = ["Revenue", "COGS", "Opex", "Asset", "Liability", "Equity"];
const THRESHOLD_RULE = "Threshold breach";

// Batch 20 · F-153: the confidence level is a percentage typed by the auditor — 25 to 100 inclusive, a whole number or one
// decimal. Returns "" when valid, else the reason (an i18n key). Nothing is sent while it is invalid.
export function confidencePctError(raw) {
  const v = String(raw ?? "").trim();
  if (!v) return "fxA.sampling.confidenceRequired";   // F3: empty = not chosen yet (no default level)
  if (!/^\d{1,3}(\.\d)?$/.test(v)) return "sampling.confidenceInvalid";
  const n = Number(v);
  if (!(n >= 25 && n <= 100)) return "sampling.confidenceInvalid";
  return "";
}
export const confidencePctToFraction = (pct) => Math.round(Number(pct) * 10) / 1000;   // 92.5 → 0.925
export const confidenceLabel = (fraction) => {   // 0.95 → "95%", 0.925 → "92.5%"
  const v = Math.round(Number(fraction) * 1000) / 10;
  return `${v}%`;
};

export { CONTINUOUS_METHOD, arEntriesLabel, SPECIFIC_METHOD, SPECIFIC_REASONS, METHODS, CATEGORIES, THRESHOLD_RULE };
